(function () {
    'use strict';

    if (window.__collectionViewToggleReady) return;
    window.__collectionViewToggleReady = true;

    var ACTIVE = 'model-view-active';

    function sync() {
        var pressed = document.body.classList.contains(ACTIVE) ? 'true' : 'false';
        document.querySelectorAll('.product-view-toggle').forEach(function (btn) {
            btn.setAttribute('aria-pressed', pressed);
        });
    }

    // Delegado: el boton puede recrearse si la seccion se vuelve a renderizar.
    document.addEventListener('click', function (event) {
        var toggle = event.target.closest('.product-view-toggle');
        if (!toggle) return;

        event.preventDefault();
        document.body.classList.toggle(ACTIVE);
        sync();
    });

    // Repara aria-pressed si el nav se regenera. El texto visible ya lo maneja
    // el CSS, asi que esto es solo accesibilidad.
    function watchNav() {
        var nav = document.querySelector('[data-collection-nav]');
        if (!nav || !nav.parentNode || !window.MutationObserver) return;
        new MutationObserver(sync).observe(nav.parentNode, { childList: true });
    }

    function init() {
        sync();
        watchNav();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
